<div class="container">
    <div class="row">
        <div class="col-12">
            <h4 mat-dialog-title *ngIf="isDownloading">Téléchargement en cours...</h4>
            <h4 mat-dialog-title *ngIf="isLoading">Chargement en cours...</h4>
            <hr>
        </div>
    </div>
    <div class="row" *ngIf="isDownloading">
        <div class="col-12">
            <div class="text-center">{{progress}} %</div>
            <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                    [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100"
                    [style]="'width: '+progress+'%'"></div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="isLoading">
        <div class="col-12">
            <div class="text-center">{{fileProgress.loaded | fileSize}}/{{fileProgress.total | fileSize}}
                ({{fileProgress.progressPercent | number : '1.2-2'}}%)
            </div>
            <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                    [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100"
                    [style]="'width: '+progress+'%'"></div>
            </div>
        </div>
    </div>
    <div class="row modal-actions">
        <div class="col align-items-end modal-footer">
            <button type=" button" class="btn btn-secondary" data-dismiss="modal" (click)="onCancel();">Annuler</button>
        </div>
    </div>
</div>